module.exports = __webpack_public_path__ + "static/media/ImageBackground.fd34bdbc.svg";